import axios from 'axios';
import routerHistory from 'router-history';

export const downloadFile = (fileName, fileUrl) => {
  return new Promise(async (resolve, reject) => {
    if (fileUrl) {
      const resp = await axios.get(fileUrl);
      const blobUrl = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      resolve('success');
    } else {
      reject(Error('Error Getting The File URL'));
    }
  });
};

export const removeQuery = (optionalNewLocation = null, ...queryNames) => {
  const location = { ...routerHistory.location };
  const params = new URLSearchParams(location.search);

  queryNames.forEach((q) => delete params[q]);

  let str = [];
  for (const [k, v] of params) {
    str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
  }
  location.search = '?' + str.join('&');

  routerHistory.push(optionalNewLocation ? optionalNewLocation : location);
};

const formats = {
  ogg: 'video/ogg; codecs="theora"',
  h264: 'video/mp4; codecs="avc1.42E01E"',
  webm: 'video/webm; codecs="vp8, vorbis"',
  vp9: 'video/webm; codecs="vp9"',
  hls: 'application/x-mpegURL; codecs="avc1.42E01E"',
};
let dummyVideo;
export const supportsVideoType = (type) => {
  if (!dummyVideo) {
    dummyVideo = document.createElement('video');
  }

  return dummyVideo.canPlayType(formats[type] ?? type);
};

export const removeTokenFromQuery = () => removeQuery('/', 'token');
